import PropTypes from 'prop-types'
import CreditBoosterIcon from '@/containers/SubscriptionFormPageNew/Components/CreditBooster/credit_booster.svg';
import {
  StyledContainer,
  StyledTitle,
  StyledEmptyMessageContainer,
  StyledEmptyIcon,
  StyledEmptyText,
  StyledTopContainerEmpty,
  StyledHeaderEmpty
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CreditBooster/styled-components'

const CreditBoosterEmpty = ({ t }) => (
  <StyledContainer>
    <StyledTopContainerEmpty>
      <StyledHeaderEmpty>
        <StyledTitle>{t('subscriptionForm:credit_booster.title')}</StyledTitle>
      </StyledHeaderEmpty>
    </StyledTopContainerEmpty>
    <StyledEmptyMessageContainer>
      <StyledEmptyIcon src={CreditBoosterIcon} alt="Credit Booster Icon" />
      <StyledEmptyText>
        {t('subscriptionForm:credit_booster.empty_text')}
      </StyledEmptyText>
    </StyledEmptyMessageContainer>
  </StyledContainer>
);

CreditBoosterEmpty.propTypes = {
  t: PropTypes.func,
}

export default CreditBoosterEmpty;
